export default __webpack_public_path__ + "static/media/woman-with-red-headphones.55c57d7d.svg";